import { DeterministicView } from '@bingads-webui/deterministic-view';
import { TargetingType, TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { createAllSettingsGrid } from '@bingads-webui-campaign/all-settings-grid';
import SettingsSummaryTemplate from './index.pug';
import { getAdditionalPlugins } from './additional-plugins';
import { fetchPreferenceConfig } from './fetch-preference-config';
import SettingsGridView from './settings-grid-view';

export class SettingsSummaryView extends DeterministicView {
  initialize({
    dataSource,
    perfMarker,
  }) {
    super.setState({ setting: TargetingType.AllSettings });
    const useNewAllSettingsGrid =
      TargetingSettingsContext.pageContext.Permissions.IsNewAllSettingsGridComponentUsageEnabled;
    if (useNewAllSettingsGrid) {
      const gridName = 'settings_settings';
      fetchPreferenceConfig(gridName).then((preferenceConfig) => {
        const gridView = createAllSettingsGrid({
          preferenceConfig,
          dataSource,
          gridName,
          getAdditionalPlugins,
          perfMarker,
        });
        this.setChild('settings-container', gridView);
      });
    } else {
      this.setChild('settings-container', new SettingsGridView({
        dataSource,
        perfMarker,
      }));
    }
  }

  get className() { return 'settings-summary-view'; }

  get template() { return SettingsSummaryTemplate; }
}
